import { useQuery } from '@tanstack/react-query';
import { Div, Select, Typography } from '@icecreamsocial/components';
import { useField, useFormikContext } from 'formik';
import React, { useImperativeHandle, forwardRef, useState, useEffect } from 'react';
import { queryKeys } from '../../../queries/marketSegments';
import { useStore } from '../../../utils/hooks';
import { V2 } from '@icecreamsocial/api-resources';
import type {
	SegmentSelectorProps,
	SegmentSelectorRef,
	SelectOption,
} from './types';
import { useMarketSegments } from '../../../utils/hooks/useMarketSegments';

export const SegmentSelector = forwardRef<SegmentSelectorRef, SegmentSelectorProps>(({ type, name, placeholder, ...rest }, ref) => {
	const { data, isLoading, formatSegmentsToOptions } = useMarketSegments(type);
	const [field, , helpers] = useField(name);

	/**
	 * expose the `clearSelect` method on the ref of this component
	 */
	useImperativeHandle(ref, () => ({
		clearSelect: () => {
			helpers.setValue(null);
		},
	}));

	const onChange = (value: SelectOption) => helpers.setValue(value);

	/**
	 * imperatively set the field to touched on blur
	 */
	const onBlur = () => helpers.setTouched(true);

	if (isLoading) return (<Div optimistic padding='12px' borderRadius='default' >
		<Typography.P margin='0'> &nbsp; </Typography.P>
	</Div>);

	return (<Select
		{...field}
		placeholder={data?.length ? placeholder : 'No items'}
		onChange={onChange}
		onBlur={onBlur}
		options={formatSegmentsToOptions()}
		{...rest}
	/>);
});